import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";

interface WorkflowPageFooterProps {
  hasUnsavedChanges: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export function WorkflowPageFooter({
  hasUnsavedChanges,
  onCancel,
  onSave,
}: WorkflowPageFooterProps) {
  const { t } = useTranslation();

  return (
    <>
      <Button variant="outline" onClick={onCancel}>
        {t(($) => $.commons.workflow.cancel)}
      </Button>
      <Button disabled={!hasUnsavedChanges} onClick={onSave}>
        {t(($) => $.commons.workflow.saveChanges)}
      </Button>
    </>
  );
}
